import React, { useEffect, useState } from 'react'
import ActionButton from '../../components/Buttons/ActionButton'

import { ReactComponent as ArrowDownicon } from '../../assets/icons/arrow_down.svg'
import { ReactComponent as PlayIcon } from '../../assets/icons/play.svg'
import { NavLink } from 'react-router-dom'
import UserService from '../../services/UserService'
import ActionInput from './ActionInput'
import { useAction } from '../../Api/newSockets.api'

type Props = {
    action: any
    deviceId: any
}

const ActionListItem = (props:Props) => {

    const [expanded, setExpanded] = useState(false)
    const [inputs, setInputs] = useState(props.action?.inputs);

    const { runAction } = useAction();

    //let inputsDefaultValue:any = {}
    // props.inputs.forEach(function(x:any) {inputsDefaultValue[x] = ""});


    const toggle = () => {
        setExpanded(!expanded)
    }
    const run = (e: React.MouseEvent<HTMLElement>) => {
        console.log(props.action, props.deviceId);
        runAction({ id: props.action.id, inputs: inputs}, props.deviceId);
        e.stopPropagation()
    }
    const updateInput = (newInput: any) => {
        var newInputs = inputs.map((input:any) => input.label == newInput.label ? input = newInput : input);
        props.action.inputs = newInputs;
        setInputs(newInputs)
    }

    
    return(
        <div className="list-item">
            <div className="list-item-header" onClick={toggle}>
                <div className="list-item-title"> 
                    <NavLink to={`/develop/${ props.action?.id }`} >
                        { props.action?.name}
                    </NavLink>
                </div>
                <div className="list-item-actions">
                    <ActionButton icon={<PlayIcon />} onClick={run} className="list-item-action"/>
                    {inputs?.length> 0 && <ActionButton icon={<ArrowDownicon className={expanded ? 'rotated': ''}/>} className={`list-item-action `} />}
                </div>
            </div>
            <div className={`list-item-body ${expanded && 'expanded'}`}>
                <form className="action">
                { 
                props.action?.inputs?.map((input:any, i:any) =>
                   <ActionInput key={i} input={input} onChange={updateInput}/>
                )}
                </form>
            </div>
        </div>  
    )
    
}

export default ActionListItem;
